import React, { useState } from 'react';
import Joi from 'joi-browser';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import PropTypes from 'prop-types';
import {
  Box,
  Modal,
  TextField,
  Button,
  Divider,
  Typography,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import makeStyles from '@mui/styles/makeStyles';
import { addUser } from '../../../../../../../redux/user/actions';

import styles from './styles';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  bgcolor: 'background.paper',
  p: 4,
  overflow: 'auto',
  maxHeight: '95%',
};

const useStyles = makeStyles(styles);

export const NewUserModalComponent = ({
  open,
  onNewUser,
  onCancel,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { isUpdatingBarnUsers } = useSelector((state) => state.barn);

  const [firstName, setFirstName] = useState('');
  const [firstNameValid, setFirstNameValid] = useState(true);
  const [lastName, setLastName] = useState('');
  const [lastNameValid, setLastNameValid] = useState(true);
  const [email, setEmail] = useState('');
  const [emailValid, setEmailValid] = useState(true);
  const [error, setError] = useState('');

  const handleSaveName = () => {
    setError(false);
    if (email && Joi.validate(email, Joi.string().email()).error) {
      setEmailValid(false);
      return;
    } setEmailValid(true);
    if (firstName.length < 2 || firstName.length > 50) {
      setFirstNameValid(false);
      return;
    } setFirstNameValid(true);
    if (firstName.length < 2 || firstName.length > 50) {
      setLastNameValid(false);
      return;
    } setLastNameValid(true);
    dispatch(addUser({
      email: email || null,
      firstName,
      lastName,
      roles: '[user]',
    }, false)).then((data) => {
      onNewUser(data);
    }).catch((responseError) => {
      setError(responseError.data && responseError.data.message
        ? responseError.data.message
        : 'There was an error adding user, please contact support.');
    });
  };

  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby="modal-add-access-note"
      aria-describedby="modal-add-horse-access-description"
    >
      <Box sx={modalStyle}>
        <form>
          <TextField
            required
            className={classes.textField}
            size="small"
            error={!firstNameValid}
            margin="normal"
            variant="outlined"
            id="first-name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            label="First Name"
            helperText={!firstNameValid && 'Please provide a first name'}
          />
          <TextField
            required
            className={classes.textField}
            size="small"
            error={!lastNameValid}
            margin="normal"
            variant="outlined"
            id="last-name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            label="Last Name"
            helperText={!lastNameValid && 'Please provide a last name'}
          />
          <TextField
            className={classes.textField}
            size="small"
            error={!emailValid}
            margin="normal"
            variant="outlined"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            label="Email"
            helperText={!emailValid && 'Provide a valid email'}
          />
        </form>
        <Divider />
        <div className={classes.footer}>
          {error && <Typography component="div" paddingBottom variant="caption" color="error">{error}</Typography>}
          <Button
            onClick={onCancel}
            disabled={isUpdatingBarnUsers}
            id="cancel-edit-button"
          >
            Cancel
          </Button>
          <LoadingButton
            onClick={handleSaveName}
            loading={isUpdatingBarnUsers}
            color="primary"
            variant="contained"
            autoFocus
            id="confirm-save-button"
          >
            Save
          </LoadingButton>
        </div>
      </Box>
    </Modal>
  );
};

NewUserModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onNewUser: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
NewUserModalComponent.defaultProps = { };

export default NewUserModalComponent;
